export const APPLY_USER_ROLE = "APPLY_USER_ROLE";

export const applyUserRole = (userRole: any) => {

  return {
    type: APPLY_USER_ROLE,
    payload: userRole
  };
};